export const FUNDED_BY_NAME_MAX_LENGTH = 190;
export const IMPACT_GROUP_NAME_MAX_LENGTH = 50;
export const MAX_QUANTITY_DECIMAL_PLACES = 3;
